import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import styled from 'styled-components';
import { StatusCodes } from 'http-status-codes';

import ButtonComponent from './forms/Button/ButtonComponent';
import { useHistory } from 'react-router-dom';
import BorderlessButton from './forms/Button/BorderlessButton';
import deleteIcon from '../../static/img/deleteIcon.svg';
import PrimaryButton from './forms/Button/PrimaryButton';
import SecondaryButton from './forms/Button/SecondaryButton';

interface Props {
  onDelete: any;
  id: string;
  title: string;
  icon: any;
  updateMovemnt: boolean;
  setUpdateMovemnt: any;
}

export default function DeleteComponent({
  onDelete,
  id,
  title,
  icon,
  updateMovemnt,
  setUpdateMovemnt,
}: Props): JSX.Element {
  const [locationModalVisible, setLocationModalVisible] = useState(false);
  const history = useHistory();

  const del = async (): Promise<void> => {
    const res = await onDelete(id);
    if (res.status === StatusCodes.OK) {
      setLocationModalVisible(false);
      setUpdateMovemnt(!updateMovemnt);
    }
  };

  return (
    <div>
      <BorderlessButton
        title="Delete"
        icon={deleteIcon}
        size="sm"
        onClick={(): void => {
          setLocationModalVisible(true);
        }}
      />

      <Wrapper isOpen={locationModalVisible} style={{ overlay: { zIndex: 10 } }}>
        <ModalContent>
          <Title>Are you sure you want to delete</Title>
          <ButtonWrapper>
            <SecondaryButton
              onClick={(): void => {
                setLocationModalVisible(false);
              }}
              title="Close"
              isBig
            />
            <PrimaryButton onClick={del} title="Delete" />
          </ButtonWrapper>
        </ModalContent>
      </Wrapper>
    </div>
  );
}

const Title = styled.h1`
  text-align: center;
  margin-bottom: 50px;
  color: #642b26;
  font-size: 20px;
  font-weight: bold;
  padding: 0;
`;

const Wrapper = styled(Modal)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #f4f4f4;
  border-radius: 10px;
  padding: 25px 50px;
`;

const ModalContent = styled.div`
  h1 {
    font-size: 30px;
    padding: 1em;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;

  button {
    margin: 0 10px;
  }
`;
